/* ---------------- helper ip / device -------------------- */
const fetchIp = async () => {
  try {
    const r = await fetch("https://api.ipify.org?format=json");
    const j = await r.json();
    return j.ip || "";
  } catch {
    return "";
  }
};

const parseDeviceModel = (ua) => {
  const m = ua.match(/\(([^)]+)\)/);
  return m ? m[1].split(";")[0].trim() : ua;
};

const getFcmTokenSafely = async () => {
  try {
    // const token = await getFcmToken(firebaseMessaging, { vapidKey: "…" });
    // return token;
    return "";
  } catch {
    return "";
  }
};

/* ======================================================== */
/*  COMPONENTE LOGIN AFFILIATI                               */
/* ======================================================== */
function AffiliateLogin() {
  /* ---------------- state ---------------- */
  const [form,      setForm]      = React.useState({ email: "", code: "" });
  const [step,      setStep]      = React.useState(1);      // 1=email, 2=codice
  const [loading,   setLoading]   = React.useState(false);
  const [errors,    setErrors]    = React.useState({});
  const [navLinks,  setNavLinks]  = React.useState({});
  const [ready,     setReady]     = React.useState(false);
  const [loginUrl,  setLoginUrl]  = React.useState("");     // invia e-mail
  const [codeUrl,   setCodeUrl]   = React.useState("");     // verifica codice
  const [resendIn,  setResendIn]  = React.useState(0);      // timer resend

  /* ---------------- device info una sola volta ---------- */
  const deviceRef = React.useRef(null);
  React.useEffect(() => {
    (async () => {
      const ua       = navigator.userAgent || "";
      const storedId = localStorage.getItem("device_uuid");
      const uuidDev  = storedId || uuid.v4();
      localStorage.setItem("device_uuid", uuidDev);

      deviceRef.current = {
        device_unique_id : uuidDev,
        device_ip        : await fetchIp(),
        device_model     : parseDeviceModel(ua),
        fcm_token        : await getFcmTokenSafely(),
        user_agent       : ua
      };
    })();
  }, []);

  /* ---------------- bootstrap: URL e link nav ----------- */
  React.useEffect(() => {
    (async () => {
      try {
        const res = await callServerNoAuth("affiliati-login-page");
        if (res.success) {
          setLoginUrl(res.login);          // POST /invio-codice
          setCodeUrl(res.confirmCode);     // POST /verifica-codice
          setNavLinks(res.navLinks);
          setReady(true);
        } else {
          window.location.href = res.nextpage;
        }
      } catch {
        //logout_function();
      }
    })();
  }, []);

  /* ---------------- timer resend ------------------------ */
  React.useEffect(() => {
    if (resendIn === 0) return;
    const t = setInterval(() => setResendIn((s) => s - 1), 1000);
    return () => clearInterval(t);
  }, [resendIn]);

  /* ---------------- handlers ---------------------------- */
  const handleChange = (e) =>
    setForm((s) => ({ ...s, [e.target.id]: e.target.value }));

  /** step-1: invia codice */
  const handleSendEmail = async (e) => {
    e.preventDefault();
    setErrors({});
    setLoading(true);

    try {
      const payload = { email: form.email, device: deviceRef.current };
      const res = await callServerNoAuth(loginUrl, payload, "POST");

      if (res.success) {
        setStep(2);
        setResendIn(60);                // blocca “Resend” per 60 s
      } else {
        setErrors(res.errors || { server: res.message });
      }
    } catch {
      setErrors({ server: "Errore di connessione" });
    } finally {
      setLoading(false);
    }
  };

  /** step-2: verifica codice */
  const handleVerifyCode = async (e) => {
    e.preventDefault();
    setErrors({});
    setLoading(true);

    try {
      const payload = {
        email : form.email,   // ← la rimandi!
        code  : form.code,
        device: deviceRef.current
      };
      const res = await callServerNoAuth(codeUrl, payload, "POST");

      if (res.success) {
        await storeTokens(res.access_token, res.refresh_token);
        window.location.href = res.nextpage || "/affiliati/dashboard";
      } else {
        setErrors(res.errors || { server: res.message });
      }
    } catch {
      setErrors({ server: "Errore di connessione" });
    } finally {
      setLoading(false);
    }
  };

  /** resend codice */
  const handleResend = async () => {
    if (resendIn > 0) return;
    setLoading(true);
    setErrors({});

    try {
      const payload = { email: form.email, device: deviceRef.current };
      const res = await callServerNoAuth(loginUrl, payload, "POST");
      if (!res.success) {
        setErrors(res.errors || { server: res.message });
      }
      setResendIn(60);
    } catch {
      setErrors({ server: "Errore di connessione" });
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- render ------------------------------ */
  if (!ready) return null;

  return (
    <>
    <div className="c_d-flex c_w-100 c_flex-col c_aff-bg c_gap-3">

        <main className="c_main c_relative c_justify-content-center" style={{height: "calc(100vh - 12rem)"}}>
            <section className="c_container c_justify-content-center">

            {step === 1 && (
                <form className="c_form c_affiliate-form" onSubmit={handleSendEmail}>
                <h2 className="c_text-center c_py-3">Accesso Dashboard</h2>

                    <p className="c_font-2 c_text-center c_py-3">Invieremo il codice di accesso al tuo indirizzo email.</p>

                <div className="c_form-item">
                    <label htmlFor="email" className="c_font-3">Email</label>
                    <input
                    id="email"
                    type="email"
                    value={form.email}
                    onChange={handleChange}
                    placeholder="Inserisci la tua email"
                    autoFocus
                    />
                    {errors.email && <span className="error-message">{errors.email}</span>}
                </div>

                {errors.server && <div className="error-messages">{errors.server}</div>}

                <button className="c_primary-button" type="submit" disabled={loading}>
                    {loading ? 
                        <span id="loader" className="loader loader-small c_white" style={{ display: loading ? 'block' : 'none' }} role="status" aria-live="polite"></span>
                    : "Invia codice"}
                </button>
                </form>
            )}

            {step === 2 && (
                <form className="c_form" onSubmit={handleVerifyCode}>
                <h2 className="c_text-center c_py-3">Codice di verifica</h2>
                <p className="c_text-center c_font-2">
                        Abbiamo inviato un codice temporaneo a 6 cifre al tuo indirizzo email.
                </p>

                <div className="c_form-item">
                    <label htmlFor="code">Codice</label>
                    <input
                    id="code"
                    type="text"
                    maxLength="6"
                    value={form.code}
                    onChange={handleChange}
                    placeholder="Inserisci il codice"
                    autoFocus
                    />
                    {errors.code && <span className="error-message">{errors.code}</span>}
                </div>

                {errors.server && <div className="error-messages">{errors.server}</div>}
                
                    <p className="c_font-2 c_text-center c_py-3">Non hai ricevuto alcun codice?&nbsp;
                        <button className="c_font-800 c_no-style c_hover c_clr-black" type="button" onClick={handleResend} title="Rinvia codice" disabled={resendIn > 0 || loading}>
                            <span>Richiedi un nuovo codice</span>
                        </button>.
                    </p>

                <button className="c_primary-button" type="submit" disabled={loading}>
                    {loading ? 
                        <span id="loader" className="loader loader-small c_white" style={{ display: loading ? 'block' : 'none' }} role="status" aria-live="polite"></span>
                    : "Verifica"}
                </button>
                </form>
            )}
            </section>
        </main>
        
        <footer className="c_footer c_bg-transparent c_clr-black">
            <div className="c_footer-container c_px-5">
                <div className="c_d-flex c_w-100 c_justify-content-between c_gap-2 c_flex-wrap c_font-2">
                    <div className="c_d-flex c_w-100 c_text-left">
                        &copy;2025 Tutti i diritti riservati &mdash; Narthex S.r.l. &mdash; Sede legale: Corso Unione Sovietica 248, 10134 Torino (TO), Italia &mdash; C.F./P.IVA 13292010017 &mdash; Iscrizione al registro delle imprese di Torino n. 13292010017 &mdash; REA TO-1352849 &mdash; Capitale sociale &euro;2500
                    </div>
                    <div class="c_d-flex c_col-gap-2 c_row-gap-1 c_flex-wrap">
                        <a href="https://www.lastoa.com/privacy" class="c_no-style c_opacity-1-hover" title="Informativa sul trattamento dei dati">Privacy Policy</a>
                        <a href="https://www.lastoa.com/privacy#cookie-policy" class="c_no-style c_opacity-1-hover" title="Informativa sui cookie">Cookie Policy</a>
                        <a href="https://www.lastoa.com/termini_e_condizioni" class="c_no-style c_opacity-1-hover" title="Termini e condizioni d'uso">Termini e Condizioni</a>
                        <a href="mailto:assistenza@lastoa.com" class="c_no-style c_opacity-1-hover" title="Scrivi all'assistenza">Assistenza</a>
                    </div>
                </div>
            </div>
        </footer>
    </div>
    </>
  );
}
  